import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";

export function CTASection() {
  const { t } = useI18n();

  return (
    <section className="w-full py-16 md:py-24 bg-white">
      <div className="mx-auto max-w-3xl px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-[#0a1733] mb-8">
          {t.home.ctaTitle}
        </h2>
        <Button asChild size="lg" className="bg-[#ff4a01] text-white hover:bg-[#e54400] border-0 rounded-[10px]">
          <Link href="/seller">
            {t.home.createLink}
            <ArrowRight className="size-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
}
